var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPalette(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 12.0422 24 12.0844 24 12.1266C23.9812 13.8375 22.425 15 20.7141 15H16.125C14.8828 15 13.875 16.0078 13.875 17.25C13.875 17.4094 13.8937 17.5641 13.9219 17.7141C14.0203 18.1922 14.2266 18.6516 14.4281 19.1156C14.7141 19.7625 14.9953 20.4047 14.9953 21.0844C14.9953 22.575 13.9828 23.9297 12.4922 23.9906C12.3281 23.9953 12.1641 24 11.9953 24C5.37187 24 0 18.6281 0 12C0 5.37188 5.37188 0 12 0C18.6281 0 24 5.37188 24 12ZM6 13.5C6 12.6703 5.32969 12 4.5 12C3.67031 12 3 12.6703 3 13.5C3 14.3297 3.67031 15 4.5 15C5.32969 15 6 14.3297 6 13.5ZM6 9C6.82969 9 7.5 8.32969 7.5 7.5C7.5 6.67031 6.82969 6 6 6C5.17031 6 4.5 6.67031 4.5 7.5C4.5 8.32969 5.17031 9 6 9ZM13.5 4.5C13.5 3.67031 12.8297 3 12 3C11.1703 3 10.5 3.67031 10.5 4.5C10.5 5.32969 11.1703 6 12 6C12.8297 6 13.5 5.32969 13.5 4.5ZM18 9C18.8297 9 19.5 8.32969 19.5 7.5C19.5 6.67031 18.8297 6 18 6C17.1703 6 16.5 6.67031 16.5 7.5C16.5 8.32969 17.1703 9 18 9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalette);
export default __webpack_public_path__ + "static/media/palette.f782a7ace487d1e6dc662e64663a480d.svg";
export { ForwardRef as ReactComponent };